export const USER_ROLES = {
    ADMIN: 'admin',
    USER: 'user',
    AGENCY: 'agency',
    ACCOUNT: 'account',
};
export const GHLLanguageKeysMapper = {
    en_US: 'en_US',
    da: 'da',
    nl: 'nl',
    fi: 'fi',
    fr_FR: 'fr',
    fr_CA: 'fr_CA',
    de: 'de_DE',
    it: 'it',
    no: 'nb',
    pt_PT: 'pt',
    pt_BR: 'pt_BR',
    es: 'es',
    sv: 'sv',
};
export const VIEW_OPTIONS = [
    { name: 'timeGridDay', tab: 'day', title: 'Day', value: 'timeGridDay' },
    { name: 'timeGridWeek', tab: 'week', title: 'Week', value: 'timeGridWeek' },
    { name: 'dayGridMonth', tab: 'month', title: 'Month', value: 'dayGridMonth' },
];
export const FILTER_OPTIONS = [
    { label: 'All', key: 'All' },
    { label: 'Appointment', key: 'Appointment' },
    { label: 'Blocked Slots', key: 'Blocked Slots' },
];
export const SELECTION_COLORS = [
    '#004EEB',
    '#027A48',
    '#026AA2',
    '#C11574',
    '#3538CD',
    '#C01048',
    '#5925DC',
    '#E62E05',
    '#175CD3',
    '#363F72',
];
export const BOOKED_STATUS = 'booked';
export const NEW_APPOINMENT = 'new';
export const CONFIREMED_APPOINMENT = 'confirmed';
export const CANCELLED_APPOINMENT = 'cancelled';
// export const AVAILAIBLE_STATUS = 'available'
// export const UNAVAILAIBLE_STATUS = 'unavailable'
